'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var convertId = '';

var loadHeadLineJs = function loadHeadLineJs() {
    window._tt_config = true;
    var ta = document.createElement('script');
    ta.type = 'text/javascript';
    ta.async = true;
    ta.src = 'https://s3.pstatp.com/bytecom/resource/track_log/src/toutiao-track-log.js';
    ta.onerror = function () {
        var request = new XMLHttpRequest();
        var webUrl = window.encodeURIComponent(window.location.href);
        var jsUrl = ta.src;
        var url = '//ad.toutiao.com/link_monitor/cdn_failed?web_url=' + webUrl + '&js_url=' + jsUrl + '&convert_id=' + convertId;
        request.open('GET', url, true);
        request.send(null);
    };
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ta, s);
};

exports.default = {
    init: function init(id) {
        convertId = id;
        loadHeadLineJs();
    },
    doStatistics: function doStatistics() {
        if ((0, _typeof3.default)(window._taq) === 'object') {
            window._taq.push({
                convert_id: convertId,
                event_type: 'form'
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/channel/headline.js
// module id = 26mc
// module chunks = 11